import Cookies from "universal-cookie";

const urlMode = process.env.REACT_APP_URL_MODE;
const storeUrlMode = process.env.REACT_APP_STORE_URL_MODE;
const urlDomain = process.env.REACT_APP_URL_DOMAIN;
const storeUrlDomain = process.env.REACT_APP_STORE_URL_DOMAIN; // localhost or bukku.store
const cookiePrefix = process.env.REACT_APP_COOKIE_PREFIX;
const isDevMode = process.env.REACT_APP_ENVIRONMENT === 'development';
const {hostname} = window.location;
const {pathname} = window.location;
const cookies = new Cookies();

export function getAccessTokenAndCompanySubdomain() {
    let accessToken, companySubdomain;
    // Bukku Store: cs.bukku.store
    if (storeUrlMode === 'subdomain' && hostname.toLowerCase().endsWith(storeUrlDomain)) {
        companySubdomain = hostname.substr(0, hostname.indexOf(storeUrlDomain) - 1);
    }
    // Bukku Store: localhost:3002/store/:cs
    else if (storeUrlMode === 'single' && isDevMode && pathname.toLowerCase().startsWith('/store')) {
        companySubdomain = pathname.split('/')[2];
    }
    // Regular Routes
    else {
        accessToken = cookies.get(`${cookiePrefix}at`);
        companySubdomain = cookies.get(`${cookiePrefix}cs`);
        if (!companySubdomain && urlMode === 'subdomain') // Read subdomain from URL
            companySubdomain = hostname.substr(0, hostname.indexOf(urlDomain) - 1);
    }

    return {accessToken, companySubdomain};
}
